<template>
    <div v-if="garmentSize">
        <v-chip
            class="border border-opacity-25 flex-shrink-0"
            v-bind="$attrs"
            color="info"
            variant="flat"
            label
        >
            Size <strong class="ms-1">{{ garmentSize.name }}</strong>
        </v-chip>
    </div>
</template>

<script lang="ts" setup>
    import type { GarmentSize } from '~/types';

    defineProps({
        garmentSize: {
            type: Object as PropType<Nilish<GarmentSize>>,
            default: null
        }
    });

    defineOptions({
        inheritAttrs: false
    });
</script>

<style lang="scss"></style>
